/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TaskStatusDto } from './TaskStatusDto';
import {
    TaskStatusDtoFromJSON,
    TaskStatusDtoFromJSONTyped,
    TaskStatusDtoToJSON,
} from './TaskStatusDto';

/**
 * 
 * @export
 * @interface TaskStatusesDto
 */
export interface TaskStatusesDto {
    /**
     * Statuses of all registered background tasks
     * @type {Array<TaskStatusDto>}
     * @memberof TaskStatusesDto
     */
    tasks: Array<TaskStatusDto>;
}

/**
 * Check if a given object implements the TaskStatusesDto interface.
 */
export function instanceOfTaskStatusesDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "tasks" in value;

    return isInstance;
}

export function TaskStatusesDtoFromJSON(json: any): TaskStatusesDto {
    return TaskStatusesDtoFromJSONTyped(json, false);
}

export function TaskStatusesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskStatusesDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tasks': ((json['tasks'] as Array<any>).map(TaskStatusDtoFromJSON)),
    };
}

export function TaskStatusesDtoToJSON(value?: TaskStatusesDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tasks': ((value.tasks as Array<any>).map(TaskStatusDtoToJSON)),
    };
}

